import _ from 'lodash'

export function getJobPlanMixins(options) {
  function getJobPlan(scope, options) {
    return _.get(scope, options['jobPlanKey']);
  }

  function getJobPlanProperty(scope, options, property) {
    return getJobPlan(scope, options)[property];
  }

  function getJobPlanType(scope, options) {
    return getJobPlanProperty(scope, options, 'type');
  }

  function getJobPlanIsStandard(scope, options) {
    return getJobPlanProperty(scope, options, 'isstandard');
  }

  return {
    computed: {
      isInspect() {
        return getJobPlanType(this, options) === 'RINSPECT';
      },
      isMeter() {
        return getJobPlanType(this, options) === 'RMETER';
      },
      isProblemReform() {
        return getJobPlanType(this, options) === 'PBREFORM';
      },
      isSop() {
        return getJobPlanType(this, options) === 'SOP';
      },
      isEop() {
        return getJobPlanType(this, options) === 'EOP';
      },
      isMop() {
        let type = getJobPlanType(this, options), isStandard = getJobPlanIsStandard(this, options);
        return (type === 'LEVEL1' || type === 'LEVEL2' || type === 'LEVEL3') && isStandard === 'YES';
      },
      is3P() {
        return this.isSop || this.isEop || this.isMop;
      },
      isOther() {
        return !(this.isInspect || this.isSop || this.isEop || this.isMop);
      },
    }
  }
}

export default getJobPlanMixins({jobPlanKey: 'jobPlan'});
